class DeliveryStock extends HTMLElement{
  constructor(){
    super()
  }

  connectedCallback(){
    this.deliveryText = this.querySelector(".stock-option-time__delivery-text");
    this.deliveryTime = this.querySelector(".stock-option-time__time");
    this.cutoffTime = this.dataset.cutoffTime || "16:00";

    this.updateDelivery()

    setTimeout(()=>{
      this.updateDelivery()
    },60000)
  }

  updateDelivery(){
    if(!this.deliveryText || !this.deliveryTime) return;

    // Create date & time for germany
    const now = new Date()
    const germanyTime = new Date(now.toLocaleString("en-US", {timeZone: "Europe/Berlin"}))

    const [ cutoffHour, cutoffMinute] = this.cutoffTime.split(':').map(Number) 
    const cutoffDate = new Date(germanyTime)
    cutoffDate.setHours(cutoffHour, cutoffMinute, 0, 0)

    const passCutoff = germanyTime > cutoffDate

    // If past cutoff, set cutoff to tomorrow's cutoff time
    if(passCutoff){
      cutoffDate.setDate(cutoffDate.getDate() + 1)
      this.deliveryText.textContent = `Lieferung in 3 Werktagen`
    } else{
      this.deliveryText.textContent = `Lieferung in 2 Werktagen`
    }

    const timeDiff = cutoffDate - germanyTime
    const remainingHour = Math.floor(timeDiff / ( 1000 * 60 * 60))
    const remainingMinute = Math.floor(timeDiff % ( 1000 * 60 * 60) / (1000 * 60))

    this.deliveryTime.textContent = `- ${remainingHour} Std. ${remainingMinute} Mins`
  }

  disconnectedCallback(){}
}


customElements.define("delivery-stock", DeliveryStock)





